import * as React from 'react'

import { cn } from './cn'

export interface LinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'color'> {
  underline?: 'none' | 'hover' | 'always'
  color?: string
  /** Old MUI typography variant; only affects font size. */
  variant?: string
  component?: React.ElementType
  to?: string
}

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      underline = 'always',
      color,
      variant,
      component: Component = 'a',
      className,
      style,
      ...props
    },
    ref,
  ) => (
    <Component
      ref={ref}
      className={cn(
        'cursor-pointer text-primary decoration-primary/40',
        variant === 'body2' && 'text-sm',
        variant === 'caption' && 'text-xs',
        underline === 'none' && 'no-underline',
        underline === 'hover' && 'no-underline hover:underline',
        underline === 'always' && 'underline',
        color === 'inherit' && 'text-inherit decoration-inherit',
        className,
      )}
      style={color && color !== 'inherit' ? { color, ...style } : style}
      {...props}
    />
  ),
)
Link.displayName = 'Link'

export default Link
